// extracted by mini-css-extract-plugin
export var container = "MissionSection-module--container--ezW-n";
export var groupPhoto = "MissionSection-module--groupPhoto---iHxB";
export var recruitCake = "MissionSection-module--recruitCake--b6nP7";